import React, { ComponentType } from "react";
import Step1 from "@/shared/media/images/step-1.svg";
import Step2 from "@/shared/media/images/step-2.svg";
import Step3 from "@/shared/media/images/step-3.svg";
import NurseWithPet from "@/shared/media/images/nurse-pets.svg";
import GuyWithDog from "@/shared/media/images/guy-dog.svg";
import GirlWithDog from "@/shared/media/images/girl-dog.svg";
import One from "@/shared/media/images/1.svg";
import Two from "@/shared/media/images/2.svg";
import Three from "@/shared/media/images/3.svg";

interface Step {
    CompactIllustration: ComponentType;
    LargeIllustration: ComponentType;
    heading: string;
    description: string;
}

const STEPS: Step[] = [
    {
        CompactIllustration: Step1,
        LargeIllustration: NurseWithPet,
        heading: "Visit your vet",
        description: "of choice in the US or CAN."
    },
    {
        CompactIllustration: Step2,
        LargeIllustration: GuyWithDog,
        heading: "Submit your claim",
        description: "via our mobile app in minutes."
    },
    {
        CompactIllustration: Step3,
        LargeIllustration: GirlWithDog,
        heading: "Get reimbursed",
        description: "in 72 hours or less via direct deposit."
    }
];

const NUMBER_ICONS: ComponentType[] = [One, Two, Three];

export default function HowSpotWorks() {
    return (
        <div className="rounded-2xl bg-background-tertiary p-4 pb-5 sm:pb-4">
            <div className="text-center text-base font-bold leading-5 text-content-primary">How do Spot plans work?</div>
            <div className="flex flex-col items-start sm:hidden">
                {STEPS.map((step, index) => (
                    <div key={index} className="flex flex-row items-center gap-3">
                        <div className="-mb-3 flex">
                            <step.CompactIllustration />
                        </div>
                        <div className="-mt-2 flex flex-col gap-1">
                            <p className="text-sm font-bold leading-5 text-content-primary">{step.heading}</p>
                            <p className="text-xs leading-4 text-content-secondary">{step.description}</p>
                        </div>
                    </div>
                ))}
            </div>
            <div className="mt-3 hidden flex-col sm:flex">
                <div className="flex flex-row items-end">
                    {STEPS.map((step, index) => (
                        <div key={index} className="flex w-full justify-center sm:h-[96px] lg:h-[80px] xl:h-[96px]">
                            <step.LargeIllustration />
                        </div>
                    ))}
                </div>

                <div className="relative mt-3 flex flex-row items-center">
                    <div
                        className="absolute inset-x-9 top-1/2 h-[2px] -translate-y-1/2 lg:inset-x-1"
                        style={{
                            background: "linear-gradient(to right, white 0%, #004B63 5%, #004B63 95%, white 100%)"
                        }}
                    />
                    {NUMBER_ICONS.map((Icon, index) => (
                        <div key={index} className="relative z-10 flex w-full justify-center">
                            <Icon />
                        </div>
                    ))}
                </div>

                <div className="mt-3 flex flex-row items-start">
                    {STEPS.map((step, index) => (
                        <div key={index} className="flex w-full flex-col items-center gap-1 px-2">
                            <p className="text-center text-sm font-bold leading-5 text-content-primary">{step.heading}</p>
                            <p className="text-center text-xs font-medium leading-4 text-content-secondary">{step.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
